/**
 * Touch controls — US 12.02. The drag-stick MECHANICS live in
 * world/input/touch-source.ts (any touch anywhere steers); this module is
 * the VISUAL treatment: a stick that appears where the thumb lands, and an
 * interact button bottom-right that reflects in-range state. Controls
 * auto-hide when the keyboard takes over and reappear on the next touch.
 */
import { worldBus } from '@shared/bus.js';

const STICK_RADIUS = 26; // nub travel clamp, px

export function initTouchControls(root: HTMLElement): void {
  const base = document.createElement('div');
  base.className = 'wca-stick-base wca-touch-hidden';
  const nub = document.createElement('div');
  nub.className = 'wca-stick-nub wca-touch-hidden';

  const interact = document.createElement('button');
  interact.className = 'wca-interact-btn wca-touch-hidden';
  interact.textContent = '!';
  interact.setAttribute('aria-label', 'Interact');
  // pointerdown, not click: reacting a frame earlier matters on phones, and
  // it must not double-fire through the canvas tap path underneath.
  interact.addEventListener('pointerdown', (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    worldBus.emit('virtual-press', { intent: 'INTERACT' });
  });

  root.append(base, nub, interact);
  let touchVisible = false;

  worldBus.on('input-device', ({ kind }) => {
    const show = kind === 'touch';
    if (show === touchVisible) return;
    touchVisible = show;
    interact.classList.toggle('wca-touch-hidden', !show);
    if (!show) {
      base.classList.add('wca-touch-hidden');
      nub.classList.add('wca-touch-hidden');
    }
  });

  worldBus.on('touch-state', ({ active, originX, originY, dx, dy }) => {
    base.classList.toggle('wca-touch-hidden', !active);
    nub.classList.toggle('wca-touch-hidden', !active);
    if (!active) return;
    base.style.left = `${originX}px`;
    base.style.top = `${originY}px`;
    const len = Math.hypot(dx, dy);
    const clamp = len > STICK_RADIUS ? STICK_RADIUS / len : 1;
    nub.style.left = `${originX + dx * clamp}px`;
    nub.style.top = `${originY + dy * clamp}px`;
  });

  // The button lights up when an interaction target exists (US 12.02).
  worldBus.on('interaction-changed', ({ npcId }) => {
    interact.classList.toggle('wca-in-range', npcId !== null);
  });
}
